document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".splide-product-explore-details")
    .forEach((mainSlider) => {
      const sliderId = mainSlider.getAttribute("data-slider-id");
      const baseSliderId = sliderId.replace(/-(desktop|mobile)$/, "");

      const thumbnailSlider = document.querySelector(
        `#thumbnail-slider-explore-details-${baseSliderId}`
      );

      const isMobile = window.innerWidth <= 990;
      const hasThumbnails = !!thumbnailSlider;

      const mainSliderOptions = {
        type: isMobile ? "slide" : hasThumbnails ? "fade" : "slide",
        rewind: true,
        pagination: false,
        arrows: false,
        focus: "left",
        perPage: isMobile ? 1.2 : hasThumbnails ? 1 : 3.4,
        gap: isMobile ? "10px" : hasThumbnails ? 0 : "24px",
      };

      const main = new Splide(mainSlider, mainSliderOptions);

      if (!isMobile && hasThumbnails) {
        const thumbs = new Splide(thumbnailSlider, {
          rewind: true,
          pagination: false,
          cover: true,
          isNavigation: true,
          arrows: false,
        });

        main.sync(thumbs);
        thumbs.mount();
      }

      main.mount();
    });
});

// Your full video play/pause handlers remain exactly the same below

document
  .querySelectorAll(".product-explore-details .splide__slide")
  .forEach((slide) => {
    let videos = slide.querySelectorAll("video");
    let playBtns = slide.querySelectorAll(".play-icon");
    let pauseBtns = slide.querySelectorAll(".pause-btn");

    if (videos.length && playBtns.length && pauseBtns.length) {
      playBtns.forEach((playBtn, index) => {
        const pauseBtn = pauseBtns[index];

        playBtn.addEventListener("click", function () {
          videos.forEach((video) => video.play());

          playBtn.style.display = "none";
          if (pauseBtn) pauseBtn.style.display = "inline-block";
        });
      });

      pauseBtns.forEach((pauseBtn, index) => {
        const playBtn = playBtns[index];

        pauseBtn.addEventListener("click", function () {
          videos.forEach((video) => {
            video.pause();
          });

          pauseBtn.style.display = "none";
          if (playBtn) playBtn.style.display = "inline-block";
        });
      });
    }
  });

// Variant slider visibility logic stays the same
document.querySelectorAll(".variant-slider-wrapper").forEach((wrapper) => {
  const wrapperVariantId = wrapper.getAttribute("data-variant-id");
  const wrapperCurrentVariantId = wrapper.getAttribute(
    "data-current-variant-id"
  );
  if (wrapperVariantId === wrapperCurrentVariantId) {
    wrapper.style.display = "flex";
  } else {
    wrapper.style.display = "none";
  }
});
